import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { useLang } from "@/i18n/LanguageContext";

const CAL_URL = "https://cal.com/saber-bellaaj-5ogauj/rdv-weyb.fr";

export default function Stub({ title }) {
    const { t, prefix } = useLang();
    return (
        <section data-testid="stub-page" className="bg-weyb-ink text-white min-h-[80vh] flex items-center pt-24">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 w-full">
                <Reveal>
                    <p className="text-xs uppercase tracking-[0.22em] font-semibold text-weyb-yellow mb-6">
                        {t("stub.eyebrow")}
                    </p>
                </Reveal>
                <Reveal delay={0.08}>
                    <h1 className="font-display text-4xl md:text-6xl font-light tracking-tight leading-tight max-w-3xl">
                        {title}{t("stub.titleSuffix")}
                    </h1>
                </Reveal>
                <Reveal delay={0.16}>
                    <p className="mt-6 text-white/55 text-base md:text-lg max-w-xl leading-relaxed">
                        {t("stub.text")}
                    </p>
                </Reveal>
                <Reveal delay={0.24} className="mt-10 flex flex-wrap items-center gap-4">
                    <Link
                        to={prefix || "/"}
                        data-testid="stub-back-home"
                        className="inline-flex items-center gap-2 bg-white text-weyb-ink hover:bg-weyb-yellow px-6 py-3 rounded-sm text-sm font-semibold transition-colors"
                    >
                        <ArrowLeft size={16} />
                        {t("stub.backHome")}
                    </Link>
                    <a
                        href={CAL_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="stub-cta-booking"
                        className="inline-flex items-center gap-2 border border-white/20 text-white hover:border-weyb-yellow hover:text-weyb-yellow px-6 py-3 rounded-sm text-sm font-medium transition-colors"
                    >
                        {t("stub.cta")}
                        <ArrowUpRight size={16} />
                    </a>
                </Reveal>
            </div>
        </section>
    );
}
